import React from 'react'
import { Draggable } from 'react-beautiful-dnd'

export default class InnerList extends React.PureComponent {
  static defaultProps = {
    getDraggableProps: () => null,
  }
  render() {
    const { data, getId, renderDraggable, getDraggableProps } = this.props

    return data.map((item, index) => (
      <Draggable
        key={getId(item)}
        draggableId={getId(item)}
        index={index}
        disableInteractiveElementBlocking
        {...getDraggableProps(item, index)}
      >
        {(provided, snapshot) => renderDraggable({ item, index, provided, snapshot })}
      </Draggable>
    ))
  }
}
